import api from './api';
import ErrorService from './errorService';



export const genereService = {

  getGenere: async () => {
        try {
          const response = await ErrorService.withTimeout(api.get(`/Genere`));
          return response.data;      
        } catch (error) {
          ErrorService.handleApiError('Error al obtener:', error);
          throw error;
        }
      },



};